module.exports = __webpack_public_path__ + "assets/img/144.bcadd4f4.png";